import React from 'react';
import { Flex, Text } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import _ from 'lodash';

type TreeHeaderProps = {
	maxDepth: number;
	showPipelineColumnWithBiggerWidth: boolean;
	hasGroupBonanza: boolean;
	hasSubaccountsV2: boolean;
	actions: {
		beginMerge?: boolean;
	};
};

const TreeHeader: React.FC<TreeHeaderProps> = ({
	maxDepth,
	showPipelineColumnWithBiggerWidth,
	hasGroupBonanza,
	hasSubaccountsV2,
	actions
}) => {
	const { t } = useTranslation();
	const statusColumnWidth = actions.beginMerge ? '250px' : '150px';

	const isSubaccount = hasGroupBonanza || hasSubaccountsV2;
	const numberOfColumns = isSubaccount
		? showPipelineColumnWithBiggerWidth
			? 5
			: 4
		: showPipelineColumnWithBiggerWidth
		? 6
		: 5;

	const renderColumn = (index: number): React.ReactNode => {
		let width = '6%';
		let flex;
		let content: string | React.ReactNode = '';

		if (index === 0) {
			content = t('default.account');
			flex = isSubaccount ? '1' : undefined;
		} else if (isSubaccount) {
			if (index === maxDepth + 1) {
				width = '180px';
				content = t('default.accountManager');
			} else if (index === maxDepth + 2) {
				width = '180px';
				content = t('default.salesLast12months');
			} else if (showPipelineColumnWithBiggerWidth && index === maxDepth + 3) {
				width = '180px';
				content = t('default.pipeline');
			} else if (index === maxDepth + (showPipelineColumnWithBiggerWidth ? 4 : 3)) {
				width = '220px';
				content = (
					<Flex justifyContent="flex-end" alignItems="center">
						{t('default.journeyStep')}
					</Flex>
				);
			} else {
				return null;
			}
		} else {
			if (index === maxDepth + 1) {
				width = '25%';
				content = t('default.history');
			} else if (index === maxDepth + 2) {
				width = '15%';
				content = t('default.accountManager');
			} else if (index === maxDepth + 3) {
				width = '15%';
				content = t('default.salesLast12months');
			} else if (showPipelineColumnWithBiggerWidth && index === maxDepth + 4) {
				width = '10%';
				content = t('default.pipeline');
			} else if (index === maxDepth + (showPipelineColumnWithBiggerWidth ? 5 : 4)) {
				width = statusColumnWidth;
				content = (
					<Flex justifyContent="flex-end" alignItems="center">
						{t('default.status')}
					</Flex>
				);
			} else if (index === maxDepth) {
				width = 100 - (maxDepth * 4 + 40) + '%';
			} else {
				return null;
			}
		}

		return (
			<Text key={index} style={{ width, flex }} space="pll" color="grey-11" size="sm">
				{content}
			</Text>
		);
	};

	return (
		<Flex key="header" className="table-header-virtualized" space="pbs ptl prxl">
			{_.times(maxDepth + numberOfColumns, index => renderColumn(index)).filter(Boolean)}
		</Flex>
	);
};

export default TreeHeader;
